import { render } from "./NewComingLoader.vue?vue&type=template&id=c07a83e0"
import script from "./NewComingLoader.vue?vue&type=script&lang=js"
export * from "./NewComingLoader.vue?vue&type=script&lang=js"

import "./NewComingLoader.vue?vue&type=style&index=0&id=c07a83e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__